<template>
  <!-- Image hotspots are always shown -->
  <BrochureHotspotImageItem
    v-if="hotspot.__typename === 'HotspotImageEntity'"
    :hotspot="hotspotImage"
  />
  <BrochureHotspotLinkItem
    v-else-if="
      hotspotMode === HotspotMode.Links ||
      hotspot.__typename === 'HotspotLinkEntity' ||
      hotspotMode === HotspotMode.ProductsWithLink
    "
    :hotspot="hotspotLink"
  />
  <!--
    ProductsWithLink should be a HotspotLinkItem if there is a `url` available.
    ProductsWithoutLink should never be shown.
  ->

  <!-- <BrochureHotspotProductItem -->
  <!-- v-else-if="hotspotMode === HotspotMode.ProductsWithLink" -->
  <!-- :hotspot="hotspotProduct" -->
  <!-- /> -->
  <!-- <BrochureHotspotProductItem -->
  <!-- v-else-if="hotspotMode === HotspotMode.ProductsWithoutLink" -->
  <!-- :hotspot="hotspotProductWithoutLink" -->
  <!-- /> -->
</template>

<script setup lang="ts">
import {
  type HotspotFragment,
  type HotspotImageEntity,
  type HotspotLinkEntity,
  HotspotMode,
  type HotspotProductEntity,
} from "~/graphql/generated";

const props = defineProps<{
  hotspot: HotspotFragment;
  hotspotMode: HotspotMode;
}>();

const hotspotImage = props.hotspot as unknown as HotspotImageEntity;
const hotspotLink = props.hotspot as unknown as HotspotLinkEntity;
const _hotspotProduct = props.hotspot as unknown as HotspotProductEntity;
const _hotspotProductWithoutLink = computed(() => {
  const hotspot = { ...props.hotspot };
  delete hotspot.url;
  return hotspot as unknown as HotspotProductEntity;
});
</script>
